module.exports = __webpack_public_path__ + "img/appAsset-flag--ES.9b61f195.svg";